<app-capture
  parentType="adhoc"
  (restartFilingEvent)="onRestartFiling()"
>
</app-capture>
